import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import hi from './locales/hi.json';
import mr from './locales/mr.json';
import gu from './locales/gu.json';
import ta from './locales/ta.json';
import te from './locales/te.json';
import kn from './locales/kn.json';

const resources = {
  en: { translation: en },
  hi: { translation: hi },
  mr: { translation: mr },
  gu: { translation: gu },
  ta: { translation: ta },
  te: { translation: te },
  kn: { translation: kn }
};

// Safely read language preference — localStorage may be unavailable in incognito/PWA contexts
let savedLanguage = 'en';
try {
  savedLanguage = localStorage.getItem('selectedLanguage') || 'en';
} catch (e) {
  savedLanguage = 'en';
}

i18n?.use(initReactI18next)?.init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

// Expose i18n instance globally so the homepage language switcher can trigger changes
if (typeof window !== 'undefined') {
  window.__i18n_instance__ = i18n;
}

export default i18n;